import { groupBy } from 'lodash-es';

export const routeNames = {
  dashboardOverview: 'analytics',

  bookingOverview: 'bookings',
  bookingCreate: 'booking-create',
  bookingDetail: 'booking-item',
  bookingAdjust: 'booking-adjust',
  bookingMoveOut: 'booking-move-out',
  bookingExport: 'booking-export',
  bookingEditNotes: 'booking-edit-notes',
  bookingEditAccessManagement: 'booking-edit-access-management',
  bookingEditCustomerSharedAccess: 'booking-edit-customer-shared-access',
  bookingEditCustomInvoiceFields: 'booking-edit-custom-invoice-fields',
  bookingUpcomingInvoice: 'booking-upcoming-invoice',

  customerOverview: 'customers',
  customerCreate: 'customer-create',
  customerExport: 'customer-export',
  customerDetails: 'customer-item',
  customerEditGeneral: 'customer-edit-general',
  customerEditDetails: 'customer-edit-details',
  customerEditCustomInvoiceFields: 'customer-edit-custom-invoice-fields',
  customerEditRunningBalance: 'customer-edit-running-balance',
  customerBalanceTransactions: 'customer-balance-transactions',

  invoiceOverview: 'invoices',
  invoiceCreate: 'invoice-create',
  invoiceDetails: 'invoice-item',
  invoiceExport: 'invoice-export',
  invoiceExportCreditNote: 'invoice-export-credit-note',
  invoiceIssueCreditNote: 'invoice-issue-credit-note',
  invoiceIssueLateFee: 'invoice-issue-late-fee',

  accountingExportBmd: 'accounting-export-bmd',
  accountingExportXero: 'accounting-export-xero',
  accountingExportPdfExport: 'accounting-export-pdf-export',
  accountingExportPdfExportCreditNote:
    'accounting-export-pdf-export-credit-note',
  accountingExportDatevDownload: 'accounting-export-datev-download',
  accountingExportDatevConfigure: 'accounting-export-datev-configure',

  fecExport: 'fec-export',

  unitOverview: 'units',
  unitCreate: 'unit-create',
  unitDetails: 'unit-item',
  unitExport: 'unit-export',
  unitEditGeneral: 'unit-edit-general',
  unitEditMeasurements: 'unit-edit-measurements',

  discountOverview: 'discounts',
  discountEditGeneral: 'discount-edit-general',
  discountCreate: 'discount-create',
  discountDetails: 'discount-details',

  tenantsOverview: 'tenants',
  tenantDetails: 'tenant-item',
  tenantCreate: 'tenant-create',
  tenantEditGeneral: 'tenant-edit-general',
  tenantCreateDataImport: 'tenant-create-data-import',

  locationOverview: 'locations',
  locationDetails: 'location-item',
  locationEditGeneral: 'location-edit-general',
  locationEditUnitSettings: 'location-edit-unit-settings',
  locationEditBilling: 'location-edit-billing',
  locationEditFloors: 'location-edit-floors',
  locationEditCustomFields: 'location-edit-custom-fields',
  locationEditContracts: 'location-edit-contracts',
  locationEditEmailSettings: 'location-edit-email-settings',
  locationEditLateFee: 'location-edit-late-fee',
  locationEditLegalEntity: 'location-edit-legal-entity',
  unitTypeOverview: 'unit-types',
  unitTypeCreate: 'unit-type-create',
  unitTypeDetails: 'unit-type-item',
  unitTypeEditGeneral: 'unit-type-edit-general',
  unitTypeEditImages: 'unit-type-edit-images',
  unitTypeEditStorefront: 'unit-type-edit-storefront',
  unitTypeEditTax: 'unit-type-edit-tax',
  unitTypeAddBookingPlan: 'unit-type-add-booking-plan',
  unitTypeEditBookingPlan: 'unit-type-edit-booking-plan',

  insuranceOverview: 'insurances',
  insuranceCreate: 'insurance-create',
  insuranceDetails: 'insurance-item',
  insuranceEditGeneral: 'insurance-edit-general',
  insuranceEditStorefront: 'insurance-edit-storefront',
  insuranceEditTax: 'insurance-edit-tax',
  insuranceAddBookingPlan: 'insurance-add-booking-plan',
  insuranceEditBookingPlan: 'insurance-edit-booking-plan',

  depositOverview: 'deposits',
  depositCreate: 'deposit-create',
  depositDetails: 'deposit-item',
  depositEditGeneral: 'deposit-edit-general',
  depositEditTax: 'deposit-edit-tax',

  productOverview: 'products',
  productCreate: 'product-create',
  productDetails: 'product-item',
  productEditGeneral: 'product-edit-general',
  productEditBookingPortal: 'product-edit-booking-portal',
  productEditTax: 'product-edit-tax',

  recurringProductCreate: 'recurring-product-create',
  recurringProductDetails: 'recurring-product-item',
  recurringProductEditGeneral: 'recurring-product-edit-general',
  recurringProductEditBookingPortal: 'recurring-product-edit-booking-portal',
  recurringProductEditTax: 'recurring-product-edit-tax',
  recurringProductAddBookingPlan: 'product-add-booking-plan',
  recurringProductEditBookingPlan: 'product-edit-booking-plan',

  emailOverview: 'emails',
  emailDetails: 'email-detail',
  emailEdit: 'email-edit',
  emailDuplicate: 'email-duplicate',
  emailCreate: 'email-create',
  emailDuplicateList: 'email-duplicate-list',

  emailDomainOverview: 'email-domains',
  emailDomainCreate: 'email-domain-create',
  emailDomainVerify: 'email-domain-verify',
  emailDomainEdit: 'email-domain-edit',

  emailTemplateOverview: 'email-templates',
  emailTemplateCreate: 'email-template-create',
  emailTemplateEdit: 'email-template-edit',

  connectedApps: 'connectedApps',
  connectedAppsSensorberg: 'sensorberg-connect',
  connectedAppsSensorbergOcb: 'sensorberg_ocb-connect',
  connectedAppsSCSolutions: 'sc_solutions-connect',
  connectedAppsNoke: 'noke-connect',
  connectedAppsSedisto: 'sedisto-connect',
  connectedAppsSignable: 'signable-connect',
  connectedAppsSignableHowToSetup: 'signable-connect-how-to-setup',
  connectedAppsStripeIdCheck: 'stripe_id_check-connect',
  connectedAppsOpenTech: 'open_tech-connect',
  connectedAppsPaxtonNet2: 'paxton_net2-connect',
  connectedAppsBearBox: 'bear_box-connect',
  connectedAppsTapKey: 'tap_key-connect',
  connectedAppsAzureAd: 'sso_azure_ad-connect',
  connectedAppsVisor: 'visor-connect',
  connectedAppsVisorSetup: 'visor-connect-setup',
  connectedAppsKinnovisAccess: 'kinnovis_access-connect',
  connectedAppsKinnovisAccessSetup: 'kinnovis_access-connect-setup',

  userOverview: 'users',
  userCreate: 'user-create',
  userDetails: 'user-item',
  userEditGeneral: 'user-edit-general',

  locationSettingsOverview: 'location-settings',
  locationSettingsDetails: 'location-settings-item',
  locationSettingsEditGeneral: 'location-settings-edit-general',
  locationSettingsEditDomain: 'location-settings-edit-domain',
  locationSettingsEditBilling: 'location-settings-edit-billing',
  locationSettingsEditCategories: 'location-settings-edit-categories',
  locationSettingsEditConsents: 'location-settings-edit-consents',
  locationSettingsEditCustomerPortal: 'location-settings-edit-customer-portal',
  locationSettingsEditContact: 'location-settings-edit-contact',
  locationSettingsEditFacilityOpeningHours:
    'location-settings-edit-opening-self-storage',
  locationSettingsEditOfficeOpeningHours:
    'location-settings-edit-opening-office',
  locationSettingsEditAppearance: 'location-settings-edit-appearance',
  locationSettingsEditMarketing: 'location-settings-edit-marketing',
  locationSettingsEditIntegrations: 'location-settings-edit-integrations',

  globalSettings: 'global-settings',
  globalSettingsEditDesign: 'design-edit',
  globalSettingsEditGeneral: 'global-settings-general-edit',
  globalSettingsEditMarketing: 'global-settings-marketing-edit',
  globalSettingsEditIntegrations: 'global-settings-integrations-edit',
  globalSettingsEditConsents: 'global-settings-consents-edit',

  pdfRendererReport: 'pdf-renderer-report',
  pdfRendererReportTest: 'pdf-renderer-report-test',
  pdfRendererReportTestRenderer: 'pdf-renderer-report-renderer',

  documentTemplateList: 'document-template-list',
  documentTemplateEdit: 'document-template-edit',

  login: 'login',
  auth: 'auth',
  authAttempt: 'auth-attempt',
  logout: 'logout',
  maintenance: 'maintenance',
  votingPortal: 'votingPortal',
  forbidden: 'forbidden',
  notFound: 'notfound',

  facilityMapOverview: 'facility-map-overview',
  facilityMapEditor: 'facility-map-editor',
  facilityMapEditorCreateBooking: 'facility-map-editor-create-booking',
  facilityMapEditorAdjustBooking: 'facility-map-editor-adjust-booking',
  facilityMapMoveOut: 'facility-map-move-out',

  tasksOverview: 'tasks-overview',
  taskCreate: 'task-create',
  taskEdit: 'task-edit',
  taskMailRedirect: 'task-mail-redirect',
  tasksNotificationSettings: 'tasks-notification-settings',

  publicApi: 'public-api',

  creditNoteOverview: 'credit-notes',
  creditNoteExport: 'credit-note-export',
} as const;

// Print warning if names are not unique:
const names = groupBy(Object.values(routeNames));

for (const name of Object.values(names)) {
  if (name.length > 1) {
    console.warn(`🚨 Route name "${name[0]}" appears ${name.length} times!`);
  }
}
